export const isMobile = typeof window !== "undefined" ? window.innerWidth <= 650 : null;
export const isTablet = typeof window !== "undefined" ? window.innerWidth <= 1000 : null;